import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/agentsIncomesActions';
import * as columnFormatters from '../column-formatters';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useAgentsInvoicesUIContext} from '../AgentsIncomesUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from '../../../_common/components/CommonGrid/CommonGrid';


export function AgentsIncomesTable() {
  const intl = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'fullName',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-name', defaultMessage: 'Name'
      })
    },
    {
      accessor: 'agentID',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-agentID', defaultMessage: 'Agent ID'
      })
    },
    {
      accessor: 'email',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-email', defaultMessage: 'Email'
      })
    },
    {
      accessor: 'phone',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-phone', defaultMessage: 'Phone'
      })
    },
    {
      accessor: 'totalWithVAT',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-totalWithVAT', defaultMessage: 'Total with VAT'
      })
    },
    {
      accessor: 'lastInvoiceDate',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-lastInvoiceDate', defaultMessage: 'Last invoice date'
      })
    },
    {
      accessor: 'sendSMS',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-sendSMS', defaultMessage: ' '
      })
    },
    {
      accessor: 'sendEmail',
      Header: intl.formatMessage({
        id: 'agentsIncomes-column-sendEmail', defaultMessage: ' '
      })
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        fullName: commonColumnFormatters.BoldColumnFormatter(item.fullName),
        agentID: commonColumnFormatters.BoldColumnFormatter(item.agentId),
        email: commonColumnFormatters.BoldColumnFormatter(item.email),
        phone: commonColumnFormatters.BoldColumnFormatter(item.phone),
        totalWithVAT: commonColumnFormatters.BoldColumnFormatter(item.totalWithVAT),
        lastInvoiceDate: commonColumnFormatters.DateColumnFormatter(item.lastInvoiceDate),
        sendSMS: columnFormatters.SendSMSColumnFormatter(item),
        sendEmail: columnFormatters.SendMailColumnFormatter(item)
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'agentsIncomes',
    UIContext: useAgentsInvoicesUIContext(),
    getNewEntities: actions.getAgentsIncomes,
    getNextEntities: actions.getNextAgentsIncomes,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'invoices-table'}
    />
  );
}
